export enum ComponentFramework {
    React = "React",
    Angular = "Angular"
}